import { useState } from "react";
import ButtonLoader from "./ButtonLoader";

const DocumentTypeForm = ({ documentType, isLoading, onSubmit }) => {
  const [name, setName] = useState(documentType?.name || '');
  const [description, setDescription] = useState(documentType?.description || '');

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      name,
      description
    }

    onSubmit(payload);
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col w-full"
    >
      <div className="p-4 flex flex-col gap-4">
        <label className='flex flex-col gap-1'>
          <span>Name</span>

          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Description</span>

          <textarea
            className='border rounded-md p-2 min-h-[100px]'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </label>

        <button className="ase-button-primary h-[48px] flex items-center justify-center">
          {isLoading ? <ButtonLoader /> : 'Submit'}
        </button>
      </div>
    </form>
  )
}

export default DocumentTypeForm;
